import { IRootState, RootState } from '../root-state.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
//@ts-ignore
//@ts-ignore
import { IUserDetails, UserDetails } from '../../models/user';
import { IUserService, UserService } from '../../services';
import { getUserDefault } from '../../utils/Accessible.util';
import { IUser } from '../../models/user/user.model';

export interface IUserState extends IRootState<IUserService> {
  userInfo?: IUserDetails;
  user?: IUser;
  modules: any;
  actionType: string;
}
export class UserState extends RootState<IUserService> implements IUserState {
  /**
   *
   */
  userInfo?: IUserDetails;
  user?: IUser;
  modules: any;
  actionType: string;


  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new UserService();
    this.userInfo = Object.assign(new UserDetails);
    this.modules = {};
    this.user= {}
    this.actionType = 'PROFILE'
  }
}



// WEBPACK FOOTER //
// ./src/store/user/user-state.store.ts